module.exports = __webpack_public_path__ + "static/img/1.f78070b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/order/1.png
// module id = Wk/T
// module chunks = 29